"use strict";
/* globals module */
/**
 * @module mediaVaultStreamsRoute
 * @description Baasic MediaVault Streams Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Media Vault Streams Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../common");
var contracts_1 = require("../../core/contracts");
var MediaVaultStreamsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(MediaVaultStreamsRoute, _super);
    function MediaVaultStreamsRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.getRoute = 'media-vault-streams/{id}/{?width,height,t}';
        _this.createRoute = 'media-vault-streams/{path}';
        _this.updateRoute = 'media-vault-streams/{id}/{?width,height}';
        return _this;
    }
    /**
     * Parses get route; this route should be expanded with id or path of desired media vault stream. Additional supported items are:
     * - `width` - width of desired derived image.
     * - `height` - height of desired derived image.
     * - `t` - cache invalidation param.
     * @method
     * @example mediaVaultRoute.get({id: '<path>'});
     **/
    MediaVaultStreamsRoute.prototype.get = function (data) {
        if (!this.utility.isObject(data)) {
            data = {
                id: data
            };
        }
        return _super.prototype.baseCreate.call(this, this.getRoute, data);
    };
    /**
     * Parses create route; this route should be expanded with the path which indicates where the stream will be saved.
     * @method
     * @example mediaVaultStreamsRoute.create({path: '<path>'});
     **/
    MediaVaultStreamsRoute.prototype.create = function (data) {
        if (!this.utility.isObject(data)) {
            data = {
                path: data
            };
        }
        return _super.prototype.baseCreate.call(this, this.createRoute, data);
    };
    /**
     * Parses update route; this route should be expanded with the id or path of the previously saved media vault resource. Additional supported items are:
     * - `width` - width of desired derived image.
     * - `height` - height of desired derived image.
     * @method
     * @example mediaVaultStreamsRoute.update({id: '<path>'});
     **/
    MediaVaultStreamsRoute.prototype.update = function (data) {
        if (!this.utility.isObject(data)) {
            data = {
                id: data
            };
        }
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    var _a;
    MediaVaultStreamsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], MediaVaultStreamsRoute);
    return MediaVaultStreamsRoute;
}(common_1.BaseRoute));
exports.MediaVaultStreamsRoute = MediaVaultStreamsRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
